module.exports = __webpack_public_path__ + "static/img/for-individuals.bc77905.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/for-individuals.png
// module id = xjLr
// module chunks = 2